export default function Loader() {
  return (
    <div
      data-testid="sa-loader"
      className="flex min-h-screen items-center justify-center bg-white"
    >
      <div className="relative h-12 w-12">
        <div className="absolute inset-0 rounded-full border-2 border-slate-200" />
        <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-[var(--sa-blue)] animate-spin" />
      </div>
    </div>
  );
}
